export default __webpack_public_path__ + "static/media/ag-icon-active.3622eead.svg";